import React from 'react';
import { useSelector } from 'react-redux';

import { useTranslation } from '../../../helpers/hooks';
import { CarouselItem } from '../../../common/Carousel';
import { SearchFilter } from '../../../core/settings/interfaces';
import TimeSelect from '../../../core/settings/TimeSelect';
import { useSettings } from '../../../core/settings/hooks';
import { StepProps } from '../interfaces';
import { Value, Body, StepBody } from '../styled';
import { eventsService } from '../../../services/EventsService';
import { AppState } from '../../../store/interfaces';

export const BeginningOfWork: React.FC<StepProps> = function ({ setNextWizardStep }) {
  const { t } = useTranslation();
  const { setStartWorkTime, isChanging, daySettings } = useSettings();
  const isSettingsLoading = useSelector((app: AppState) => app.settings.isSettingsLoading);

  return (
    <CarouselItem
      isLoading={isSettingsLoading}
      onApply={setNextWizardStep}
      applyText={t('settings.wizard.buttonContinue')}
      bodyWrapper={StepBody}
    >
      <Body dangerouslySetInnerHTML={{ __html: t('settings.wizard.beginningOfWork.body') }} />
      <Value onClick={() => eventsService.toggleSettingsFilter(SearchFilter.startWork)}>
        <TimeSelect
          isChanging={isChanging.begin_work}
          handleChange={setStartWorkTime}
          value={daySettings.begin_work}
          filterName={SearchFilter.startWork}
          title={t('settings.filters.startWork')}
        />
      </Value>
    </CarouselItem>
  );
};
